module.exports = __webpack_public_path__ + "img/laying-parquet-on.abe000a2.svg";